import el from "element-ui/lib/locale/lang/en"
import fu from "fit2cloud-ui/src/locale/lang/en_US" // 加载fit2cloud的内容


const message = {
    commons: {
        message_box: {
            alert: "Warning",
            confirm: "Confirm",
            prompt: "Prompt",
        },
        personal: {
            profile: "Profile",
            exit: "Logout",
            project_url: "Project URL",
            issue: "Feedback",
            talk: "Join the discussion",
            star: "Star",
            version: "Version",
            copy_right: "Copyright © 2014-{year} FIT2CLOUD",
            one_panel_ad: "Produced by 1Panel Team",
            introduction: "KubePi is a modern K8s panel.",
            introduction2: "KubePi allows administrators to import multiple Kubernetes clusters and grant cluster- and namespace-level permissions to specific users. It helps developers manage and troubleshoot applications running in Kubernetes clusters, making cluster complexity easier to handle."
        },
        help: {
            help: "Help",
            about: "About",
            ko_docs: "Official Documentation",
            dev_doc: "Developer Documentation",
        },
        button: {
            detail: "Details",
            delete: "Delete",
            skip: "Skip",
            import: "Import",
            create: "Create",
            cancel: "Cancel",
            login: "Login",
            confirm: "Confirm",
            ok: "OK",
            add: "Add",
            edit: "Edit",
            all_select: "All",
            upload: "Upload",
            search: "Search",
            rbac_manage: "Manage RBAC",
            sync: "Sync",
            bind: "Bind",
            change_password: 'Change Password',
            reset_password: 'Reset Password',
            export: 'Export All Helm Releases',
        },
        table: {
            name: "Name",
            kind: "Kind",
            created_time: "Created At",
            age: "Age",
            status: "Status",
            action: "Action",
            creat_by: "Created By",
            built_in: "Built-in",
            description: "Description",
            empty_text: "There are no rows to show.",
            mfa_enable: "MFA"
        },
        header: {
            help_doc: "Documentation",
            support: "Support",
            guide: "Guide",
            guide_text: "Thank you for choosing this product. Would you like to register your first cluster now?"
        },
        bool: {
            true: "True",
            false: "False"
        },
        enable: {
          true: "Enable",
          false: "Disable"
        },
        search: {
            quickSearch: "Search"
        },
        form: {
            select_placeholder: "Please select"
        },
        validate: {
            limit: "Length must be between {0} and {1} characters",
            input: "Please enter {0}",
            select: "Please select {0}",
            required: "Required",
            email: "Please enter a valid email address",
            number_limit: "Please enter a valid number",
            password_help: "Password must be 8-30 characters and include letters, numbers, and special characters (~!@_#$%^&*)",
            name_not_compliant: "The name does not follow the naming convention.",
            name_rules: "Only lowercase letters, numbers, and hyphens are supported",
        },
        msg: {
            create_success: "Created successfully",
            delete_success: "Deleted successfully",
            update_success: "Updated successfully",
            duplicate_failed: "Operation failed because the data already exists.",
            no_data: "No data",
        },
        confirm_message: {
            delete: "This operation cannot be undone. Do you want to continue?",
            create_success: "Created successfully",
            save_success: "Saved successfully",
        },
        login: {
            username_or_email: "Username or Email",
            password: "Password",
            title: "Log in to KubePi",
            welcome: "Welcome back. Enter your username and password to log in.",
            expires: "The authentication information has expired. Please log in again.",
            mfa_helper: "Scan the QR code below with your MFA authenticator app to get a 6-digit verification code.",
            mfa_login_helper:"Please enter the 6-digit verification code from your MFA authenticator.",
            force_change_password_title: "Change default password",
            force_change_password_tip: "The current account is still using the default password. Change it before continuing.",
            password_same: "The new password cannot be the same as the old password.",
        },
        sso: {
            title: "Redirecting to SSO",
        },
    },
    business: {
        cluster: {
            cluster: "Cluster",
            namespace: "Namespace",
            scope: "Scope",
            version: "Version",
            list: "Clusters",
            import: "Import Cluster",
            edit_cluster: "Edit Cluster",
            edit: "Edit",
            nodes: "Nodes",
            label: "Label",
            description: "Description",
            cluster_detail: "Cluster Details",
            connect_setting: "Connection Settings",
            connect_direction: "Connection Direction",
            connect_forward: "Forward",
            connect_backward: "Backward",
            authenticate_setting: "Authentication Settings",
            certificate: "Certificate",
            authenticate_mode: "Authentication Mode",
            expect: "Coming Soon",
            management: "Management",
            open_dashboard: "Console",
            cluster_version: "Version",
            member: "Member",
            role: "Role",
            administrator: "Administrator",
            viewer: "Viewer",
            custom: "Custom",
            contains_namespace: "(contains namespace roles)",
            rule: "Rule",
            config_file: "Kubeconfig File",
            config_content: "Configuration Content",
            hidden_cluster: "Hide inaccessible clusters",
            namespace_role_form_check_msg: "Namespace and role lists cannot be empty",
            api_group: "API Groups",
            resource: "Resources",
            verb: "Verbs",
            cluster_role_form_check_msg: "API groups, resources, and verbs cannot be empty",
            user_not_in_cluster: "You are not a member of this cluster and cannot access the console of this cluster. Please contact the administrator to add you as a cluster member.",
            ready: "Ready",
            not_ready: "Not Ready",
            repo: "Repository",
            repo_auth: "Repository Authorization"
        },
        cluster_role: {
            none: "None",
            cluster_administrator: "Administrator",
            cluster_viewer: "Viewer",
        },
        user: {
            user_management: "Users",
            username: "Username",
            nickname: "Nickname",
            email: "Email",
            user_list: "User List",
            role_list: "Role List",
            user: "User",
            role: "Role",
            template: "Template",
            base_on_exists_role: "Based on Existing Role",
            permission: "Permission",
            permission_setting: "Permission Settings",
            password: "Password",
            confirm_password: "Confirm Password",
            old_password: "Old Password",
            new_password: "New Password",
            change_password: "Change Password",
            reset_password: "Reset Password",
            resource_name: "Resource Name",
            please_input_password: "Please enter a password",
            please_input_password_again: "Please enter the password again",
            password_not_equal: "The two passwords do not match",
            ldap: "LDAP",
            ldap_address: "Address",
            ldap_tls: "TLS",
            ldap_port: "Port",
            ldap_username: "User DN",
            ldap_password: "Password",
            ldap_filter_dn: "User Filtering DN",
            ldap_filter_rule: "User Filtering Rules",
            ldap_helper: "Note: Users without a mapped Name attribute will not be matched.",
            ldap_sync: "Synchronization started. Check the user list later.",
            ldap_sync_error: "Please save first",
            type: "Type",
            ldap_mapping: "User Attribute Mapping",
            ldap_mapping_helper: "User attribute mapping defines how LDAP user attributes map to KubePi users. name, nickName, and email are required KubePi user attributes.",
            ldap_test: "Test Connection",
            sso: "SSO",
            sso_protocol: "Protocol",
            sso_interface_address: "Interface Address",
            sso_client_id: "Client ID",
            sso_client_secret: "Client Secret",
            sso_x509_cert: "Certificate",
            sso_x509_key: "Certificate Key",
            sso_idp_metadata_url: "IDP Metadata URL",
            sso_test_result: "SSO connection test succeeded",
            sso_helper: "Note: If SSO is enabled, access \"http(s)://host/kubepi/login\" directly to log in with a local account.",
            sso_remake: "Reset",
            sso_test: "Test Connection",
            test_result: "Connection succeeded. {count} users matched.",
            test_login: "Test Login",
            login_success: "Test login succeeded",
            login_failed: "Login failed",
            import_user: "Import User",
            import_enable: "Importable",
            import_user_success: "Import successful",
            import_user_failed: "Failed to import user {user}",
            ldap_remake: "Reset",
            time_limit: "Connection Timeout",
            size_limit: "Search Page Size",
        },
        system: {
            system_log: "Audit Logs",
            operation_log: "Operation Logs",
            operator: "Operator",
            operation: "Operation",
            operation_domain: "Resource",
            specific_information: "Information",
            login_log: "Login Logs",
            username: "Username",
            ip: "Login IP",
            city: "Login City",
        },
        image_repos: {
          list: "Image Registries",
          name: "Name",
          endpoint: "Endpoint",
          downloadUrl: "Download URL",
          username: "Username",
          password: "Password",
          type: "Type",
          repo: "Image Repository",
          load_repo: "Load Image Repository",
          auth: "Auth",
          allow_anonymous: "Allow anonymous Docker pulls",
          repo_null: "Image repository is empty",
          images: "Image List",
          push_image: "Push image to the current project",
          version: "Version",
        },
        monitor: {
            name: "Monitor",
            grafana: {
                name: "Dashboard",
                address: "Address",
                remake: "Reset",
                test: "Test Connection",
                test_result: "Grafana connection test succeeded",
                default_dashboard: "Import Default Dashboard",
                default_dashboard_success: "Default dashboard imported successfully",
                service_account_token: "Service Account Token",
                iframe_close: "Close Dashboard",
            },
            metrics: {
                name:  "Metrics",
                type: "Type",
                endpoint: "Endpoint",
                age: "Age",
                auth: "Auth",
                username: "Username",
                password: "Password",
                instance: "Instance",
                execute: "Run Query",
            },
            alert_rules: {
                name: "Alert Rules",
            }
        }
    },
}

const description = {
    i18n_user_administrator: "Super administrator with permissions on all objects.",
    i18n_user_manage_cluster: "Cluster administrator with all permissions on cluster objects.",
    i18n_user_manage_rbac: "User and role administrator with all permissions on user management objects.",
    i18n_user_manage_repo: "Image registry administrator with all permissions on image registry objects.",
    i18n_user_manage_readonly: "Read-only user with access to all objects.",
    i18n_user_common_user: "Common user with access to cluster objects only.",
    i18n_user_manage_chart: "Chart repository administrator with all permissions on Chart repositories.",

    i18n_cluster_owner: "Cluster owner with permissions on all objects.",
    i18n_cluster_viewer: "Cluster read-only user with read-only permission on all objects.",
    i18n_manage_cluster_rbac: "Cluster access control administrator with all permissions on ClusterRole and ClusterRoleBinding objects.",
    i18n_view_cluster_rbac: "Cluster access control read-only user with read-only permission on ClusterRole and ClusterRoleBinding objects.",
    i18n_manage_cluster_storage: "Cluster storage administrator with all permissions on StorageClass and PersistentVolume objects.",
    i18n_view_cluster_storage: "Cluster storage read-only user with read-only permission on StorageClass and PersistentVolume objects.",
    i18n_manage_namespaces: "Namespace administrator with all permissions on Namespace objects.",
    i18n_view_namespaces: "Namespace read-only user with read-only permission on Namespace objects.",
    i18n_view_events: "Cluster event read-only user with read-only permission on Event objects.",
    i18n_view_nodes: "Node read-only user with read-only permission on Node objects.",

    i18n_manage_nodes: "Node administrator with all permissions on Node objects.",
    i18n_manage_crd: "Custom resource administrator with all permissions on CustomResourceDefinition objects.",
    i18n_view_crd: "Custom resource read-only user with read-only permission on CustomResourceDefinition objects.",

    i18n_manage_config: "Configuration administrator with all permissions on ConfigMap, Secret, ResourceQuota, LimitRange, HorizontalPodAutoscaler, and PodDisruptionBudget objects in the current namespace.",
    i18n_view_config: "Configuration read-only user with read-only permission on ConfigMap, Secret, ResourceQuota, LimitRange, HorizontalPodAutoscaler, and PodDisruptionBudget objects in the current namespace.",
    i18n_namespace_owner: "Namespace owner with all permissions on all objects in the current namespace.",
    i18n_namespace_viewer: "Namespace read-only user with read-only permission on all objects in the current namespace.",
    i18n_view_workload: "Workload read-only user with read-only permission on DaemonSet, StatefulSet, Deployment, Job, CronJob, and Pod objects in the current namespace.",
    i18n_manage_workload: "Workload administrator with all permissions on DaemonSet, StatefulSet, Deployment, Job, CronJob, and Pod objects in the current namespace.",
    i18n_manage_storage: "Storage administrator with all permissions on PersistentVolumeClaim objects in the current namespace.",
    i18n_view_storage: "Storage read-only user with read-only permission on PersistentVolumeClaim objects in the current namespace.",
    i18n_view_service_discovery: "Service discovery read-only user with read-only permission on Service, Endpoint, Ingress, and NetworkPolicy objects in the current namespace.",
    i18n_manage_service_discovery: "Service discovery administrator with all permissions on Service, Endpoint, Ingress, and NetworkPolicy objects in the current namespace.",
    i18n_manage_rbac: "Namespace access control administrator with all permissions on Role, RoleBinding, and ServiceAccount objects in the current namespace.",
    i18n_view_rbac: "Namespace access control read-only user with read-only permission on Role, RoleBinding, and ServiceAccount objects in the current namespace.",
    i18n_manage_appmarket: "Application marketplace administrator with all permissions on application marketplace objects."
}

const apiObjects = {
    users: "Users",
    roles: "Roles",
    clusters: "Clusters",
    systems: "Audit Logs",
}

const apiVerbs = {
    "update": "Update",
    "delete": "Delete",
    "get": "Get",
    "list": "List",
    "create": "Create",
    "privilege": "Privilege",
    "authorization": "Authorize"
}

const system_logs = {
    post: "Create",
    put: "Update",
    delete: "Delete",
    clusters: "Clusters",
    users: "User",
    roles: "Role",
    systems: "Audit Logs",
    clusters_members: "Cluster Member",
    clusters_clusterroles: "Cluster Role",
    clusters_repos: "Cluster Repositories",
    imagerepos: "Image Registries",
    ldap: "LDAP",
    sync: "Sync",
    import: "Import",
    testConnect: "Test Connection",
    testLogin: "Test Login",
}


export default {
    ...el,
    ...fu,
    ...message,
    ...apiObjects,
    ...apiVerbs,
    ...description,
    ...system_logs
}
